import * as React from 'react';
import { LazyImage } from '@grandvisionhq/common';

const CategoryLinksItem = ({ title , link , image  })=>{
    if (!image && !title) {
        console.warn(`Cannot render CategoryLink: missing content`);
        return null;
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: "category-links-item"
    }, /*#__PURE__*/ React.createElement("a", {
        className: "category-links-item__link",
        href: link.url
    }, /*#__PURE__*/ React.createElement("div", {
        className: "category-links-item__image-container"
    }, image && /*#__PURE__*/ React.createElement(LazyImage, {
        rootMargin: "50px 0px",
        src: image.url,
        alt: image.alt || '',
        width: image.dimensions.w || 274,
        height: image.dimensions.h || 108
    })), title && /*#__PURE__*/ React.createElement("span", {
        className: "category-links-item__title"
    }, title)));
};

export { CategoryLinksItem as default };
//# sourceMappingURL=CategoryLinksItem.js.map
